<template>
  <div class="checkbox-wrapper">
    <div
      :class="{'checkbox': true, 'checked': checked}"
      @click="onClick"
    >
      <img
        v-if="checked"
        :src="vIcon"
        class="checkmark"
      >
    </div>
    <slot name="title" />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import vIcon from '../../../assets/v-white.svg';

interface Props {
  toggle(): void;
  initiallyChecked: boolean;
}

const props = withDefaults(
  defineProps<Props>(),
  {
    initiallyChecked: false,
  },
);
const checked = ref(props.initiallyChecked);
const onClick = () => {
  props.toggle();
  checked.value = !(checked.value);
};
</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';

.checkbox-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  width: 100%;

  .checkbox {
    height: 24px;
    width: 24px;
    min-width: 24px;
    min-height: 24px;
    border-radius: 5px;
    cursor: pointer;

    &.checked {
      background: $riseup_blue;
    }
    &:not(.checked) {
      border: solid 1px $riseup_black;
    }

    display: flex;
    justify-content: center;
    align-items: center;

    .checkmark {

      height: 12px;
      width: 16px;
    }
  }
}
</style>
